import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/common/Navigation/Navigation';
import LoadingScreen from './components/common/LoadingScreen/LoadingScreen';
import './App.css';

// ============================================
// LAZY LOADING DES PAGES PUBLIQUES
// ============================================
const Home = lazy(() => import('./pages/Home/Home'));
const Videos = lazy(() => import('./pages/Videos/Videos'));
const Visuals = lazy(() => import('./pages/Visuals/Visuals'));
const Websites = lazy(() => import('./pages/Websites/Websites'));
const About = lazy(() => import('./pages/About/About'));

// ============================================
// LAZY LOADING DES PAGES ADMIN
// ============================================
const AdminGate = lazy(() => import('./pages/Admin/AdminGate'));
const AdminLogin = lazy(() => import('./pages/Admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/Admin/AdminDashboard'));

// ============================================
// COMPOSANT PROTECTED ROUTE
// ============================================
const ProtectedRoute = lazy(() => import('./components/admin/ProtectedRoute'));

// ============================================
// PAGE 404 SIMPLE (pour la redirection admin)
// ============================================
const NotFound = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: '#0a0a0a',
    color: '#ffffff',
    fontFamily: 'system-ui, sans-serif'
  }}>
    <h1 style={{ fontSize: '6rem', margin: 0, color: '#f59e0b' }}>404</h1>
    <p style={{ fontSize: '1.25rem', color: '#a0a0a0', marginTop: '1rem' }}>
      Page non trouvée
    </p>
    <a 
      href="/" 
      style={{
        marginTop: '2rem',
        padding: '0.75rem 1.5rem',
        background: '#f59e0b',
        color: '#0a0a0a',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: 600
      }}
    >
      Retour à l'accueil
    </a>
  </div>
);

// ============================================
// COMPOSANT PRINCIPAL APP
// ============================================
function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  // Détecter si on est sur une page admin
  const isAdminRoute = location.pathname.startsWith('/Boinzemwendeadmin');

  useEffect(() => {
    // Chargement initial
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="App">
      {/* Navigation visible uniquement sur les pages publiques */}
      {!isAdminRoute && <Navigation />}
      
      <main className={`main-content ${isAdminRoute ? 'admin-page' : ''}`}>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            {/* ============================================
                ROUTES PUBLIQUES
                ============================================ */}
            <Route path="/" element={<Home />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/visuals" element={<Visuals />} />
            <Route path="/websites" element={<Websites />} />
            <Route path="/about" element={<About />} />

            {/* ============================================
                ROUTES ADMIN (URL secrète)
                ============================================ */}
            
            {/* Étape 1: Code secret (Gate) */}
            <Route 
              path="/Boinzemwendeadmin" 
              element={<AdminGate />} 
            />
            
            {/* Étape 2: Login email/password */}
            <Route 
              path="/Boinzemwendeadmin/login" 
              element={<AdminLogin />} 
            />
            
            {/* Étape 3: Dashboard (protégé) */}
            <Route 
              path="/Boinzemwendeadmin/dashboard/*" 
              element={
                <Suspense fallback={<LoadingScreen />}>
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                </Suspense>
              } 
            />

            {/* ============================================
                PAGE 404
                ============================================ */}
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
    </div>
  );
}

export default App;